import React, {useCallback, useEffect, useState} from 'react'
import axios from 'axios'
import {Spinner} from 'react-bootstrap'
import toaster from '../../../Utils/toaster'
import {BulkVosClientPortalView} from './BulkVosClientPortalView'
import {BatchDetail} from './bulkVosTypes'
import './bulkVosClientPortal.css'

const API_URL = process.env.REACT_APP_API_URL

type Props = {
  token?: string
}

export function PartnerDisputeManagementPage({token}: Props) {
  const [loading, setLoading] = useState(true)
  const [batch, setBatch] = useState<BatchDetail | null>(null)

  const portalToken = token ?? batch?.portalToken

  const load = useCallback(async () => {
    setLoading(true)
    try {
      const res = token
        ? await axios.get(`${API_URL}/bulk-vos/batch/${token}`)
        : await axios.get(`${API_URL}/bulk-vos/active-batch`)
      if (res.data?.status === 'S') setBatch(res.data.result)
      else toaster('error', res.data?.text || 'Unable to load batch')
    } catch {
      toaster('error', 'Unable to load batch')
    } finally {
      setLoading(false)
    }
  }, [token])

  useEffect(() => {
    load()
  }, [load])

  if (loading) {
    return (
      <div className='bvp-loading' style={{backgroundColor: '#f5f8fa', minHeight: 240}}>
        <Spinner animation='border' />
      </div>
    )
  }

  if (!batch) {
    return <div className='p-10 text-center text-muted'>No batch available.</div>
  }

  if (portalToken) {
    return (
      <BulkVosClientPortalView
        batch={batch}
        portalToken={portalToken}
        tokenForDisplay={token}
        showPublicHeader={Boolean(token)}
        onReload={load}
      />
    )
  }

  return (
    <div className='p-10 text-center text-muted'>
      No active portal link for this batch. Check your invitation email or contact support.
    </div>
  )
}
